import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Atlanta.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Revolutionizing Atlanta With Our Expertise In Mobile App
              Development
            </h2>
            <p>
              TekRevol is a reliable digital solution provider in the global
              market especially when it comes to mobile app development in
              Atlanta. We've been on the pathway to growth & sustainability
              since our inception. There are different business sectors that we
              serve for their advancement to compete in the digital market. We
              understand our client’s goals and business requirements. After
              that, our professional Atlanta app developers suggest the right
              solutions based on a result-oriented approach. Using a customized
              approach, we enable businesses to magnify their online presence.
              So, connect with us today to discuss your epic app ideas!
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
